module.exports = __webpack_public_path__ + "static/media/dropdown-arrow.10f357db.svg";